import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leftArrow",
  "use": "icon-leftArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-leftArrow\"><path d=\"M750.72 60.586667c23.04 23.893333 23.04 62.677333 0 86.613333L398.592 512l352.085333 364.8c23.04 23.936 23.04 62.72 0 86.613333a57.6 57.6 0 0 1-83.584 0l-393.813333-408.106666a62.805333 62.805333 0 0 1 0-86.613334l393.813333-408.106666a57.6 57.6 0 0 1 83.584 0z\" p-id=\"10161\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol